"use strict";

var EConsentFactory = function ($resource, $window) {
  var updatePPTEConsentInd =
    "/participant-web-services/rest/partialauth/ecommService/updatePPTEConsent";

  return {
    updatePPTEConsent: $resource(
      __baseApiUrl__ + updatePPTEConsentInd,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
  };
};

EConsentFactory.$inject = ["$resource", "$window"];
export default EConsentFactory;
